module.exports = __webpack_public_path__ + "static/fondation-chanel-logo-c4c152f8f4bcd23603405ad9f726f9ee.png";